export const getType = (activity) => {
    const { type } = activity;
    const isProgram = type === 'program';
    const isPaymentRequest = type === 'payment_request';
    return {
        isProgram,
        isPaymentRequest,
    };
};
